import { createAsyncThunk } from "@reduxjs/toolkit";
import { authUserInfoService } from "services";

export const initUserSessionAction = createAsyncThunk(
  "auth/initUserSession",
  async () => {
    const getMeRes = await authUserInfoService();
    return getMeRes?.data;
  }
);
